import enviro from 'enviro';
// @ts-expect-error no types
import SafeStorage from 'SafeStorage';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const isTuesdayOrThursday = () => {
  const today = new Date();
  const day = today.getDay();
  return day === 2 || day === 4;
};
const getDayOfYear = () => {
  const today = new Date();
  return `${today.getMonth()}-${today.getDate()}`;
};
const CheckTheme = () => {
  useEffect(() => {
    const today = getDayOfYear(); // this will only switch the theme once per day, allowing the user to switch back to canvas-light if they want
    try {
      const theme = SafeStorage.getItem('trellis:theme');
      if (isTuesdayOrThursday() && theme === 'canvas-light' && SafeStorage.getItem('trellis:theme-checked-date-academy') !== today) {
        SafeStorage.setItem('trellis:theme', 'trellis-light');
        SafeStorage.setItem('trellis:theme-checked-date-academy', today);
        window.location.reload();
      }
    } catch (error) {
      void 0;
    }
  }, []);
  return null;
};
const TrellisThemeSwitcher = () => {
  if (enviro.isQa()) {
    return /*#__PURE__*/_jsx(CheckTheme, {});
  }
  return null;
};
export default TrellisThemeSwitcher;